import { render, staticRenderFns } from "./ServiceCitySelector.vue?vue&type=template&id=4cb947d1&"
import script from "./ServiceCitySelector.vue?vue&type=script&lang=js&"
export * from "./ServiceCitySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb947d1')) {
      api.createRecord('4cb947d1', component.options)
    } else {
      api.reload('4cb947d1', component.options)
    }
    module.hot.accept("./ServiceCitySelector.vue?vue&type=template&id=4cb947d1&", function () {
      api.rerender('4cb947d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/nine/components/ServiceCitySelector.vue"
export default component.exports